export default {
    confirm_delete_title: 'Tem certeza que deseja excluir a instância "{0}"?',
    confirm_delete_body: "Após exclusão, a ação será irreversível.",
    table: {
        instance_name: "Nome Instância",
        connected: "Conectada",
        linked_users: "Usuários Vinculados",
        linked_branches: "Filiais Vinculadas",
        qr_code: "QR Code",
        delete_instance: "Excluir Instância",
    },
    status: {
        connected: "Sim - {0}",
        disconnected: "Não",
        replacing: "Substituindo...",
        loading: "Carregando...",
        connected_already: "Já conectado",
    },
    buttons: {
        replace_error: "Erro, substituir instância",
        generate: "Gerar",
        disconnect: "Desconectar",
        delete: "Excluir",
        add: "Adicionar Instância",
    },
    form: {
        placeholder_name: "Nome da instância",
    },
    notifications: {
        created: "Nova instância criada",
        replaced: "Instância substituída",
        replace_error: "Erro ao substituir instância",
        disconnected: "Instância desconectada",
        disconnect_error: "Erro ao desconectar instância",
        deleted: "Instância excluída",
        server_error: "Erro interno do servidor, tente novamente mais tarde.",
    },
};
